export default __webpack_public_path__ + "static/media/techtop-full-logo.80ff5a4c.svg";